import React from 'react';
import { BugStatus, STATUS_COLORS } from '../../services/bugReportService';

interface Props {
  status: BugStatus;
  size?: 'sm' | 'md';
}

const STATUS_LABEL: Record<BugStatus, string> = {
  ABERTO: 'Aberto',
  EM_ANALISE: 'Em Analise',
  EM_CORRECAO: 'Em Correcao',
  CORRIGIDO: 'Corrigido',
  FECHADO: 'Fechado',
  NAO_REPRODUZIVEL: 'Nao Reproduzivel',
};

export const StatusBadge: React.FC<Props> = ({ status, size = 'md' }) => {
  const c = STATUS_COLORS[status];
  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs';

  return (
    <span
      className={`inline-flex items-center rounded-md border font-medium ${c.bg} ${c.text} ${c.border} ${sizeClass}`}
    >
      {STATUS_LABEL[status]}
    </span>
  );
};
